import React, { Component } from 'react';
import './NoMatch.css';

class NoMatch extends Component {
  render() {
    return (
      <div className='not-found-banner'>
        <h2>404 Page not found</h2>
      </div>
    );
  }
}

export default NoMatch;